document.addEventListener("DOMContentLoaded", function () {
    // Create the live chat button
    var chatButton = document.createElement("a");
    chatButton.classList.add("live-chat-button");
    chatButton.innerHTML = '<img src="https://cdn-icons-png.flaticon.com/512/9131/9131529.png" alt="Live Chat Icon" class="live-chat-icon"> Live Chat';
    
    // Append button to the body
    document.body.appendChild(chatButton);

    // Create the chat popup container
    var chatContainer = document.createElement("div");
    chatContainer.classList.add("chat-popup");
    chatContainer.innerHTML = '<div class="chat-header"><span>Live Chat Support</span><button class="close-chat">✖</button></div><iframe class="chat-iframe" src="https://cs-chatsupport.com/support/phplive.php?d=0&onpage=livechatimagelink&title=Live+Chat+Direct+Link&tokey=0d5a4af46ff0a436c3786c502b5d1016&token=a9feb16894463bb1eff1df29111b1f18&tokey=7031bcc0804c2458e18bbf5582953f18"></iframe>';
    
    // Append chat popup to the body
    document.body.appendChild(chatContainer);

    // Close button functionality
    var closeButton = chatContainer.querySelector(".close-chat");
    closeButton.addEventListener("click", function () {
        chatContainer.classList.remove("open");
    });

    // Toggle chat box on button click
    chatButton.addEventListener("click", function () {
        chatContainer.classList.toggle("open");
    });

    // Add styles dynamically
    var style = document.createElement("style");
    style.innerHTML = `
        .live-chat-button {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background-color: #ef4123;
            color: #fff;
            font-family: Arial, sans-serif;
            font-size: 16px;
            font-weight: bold;
            padding: 12px 20px;
            border-radius: 30px;
            display: flex;
            align-items: center;
            text-decoration: none;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease-in-out;
            z-index: 1000;
            cursor: pointer;
        }

        .live-chat-button:hover {
            background-color: #d6371f;
            transform: scale(1.05);
        }

        .live-chat-icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        .chat-popup {
            position: fixed;
            bottom: 80px;
            right: 20px;
            width: 500px;
            height: 650px;
            background: white;
            border-radius: 10px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            display: none;
            flex-direction: column;
            overflow: hidden;
            z-index: 1001;
        }

        .chat-popup.open {
            display: flex;
        }

        .chat-header {
            background: #ef4123;
            color: white;
            padding: 10px;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .close-chat {
            background: none;
            border: none;
            color: white;
            font-size: 18px;
            cursor: pointer;
        }

        .chat-iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
    
}
    `;
    document.head.appendChild(style);
});
